import { Box, Button } from '@mui/material'
import { ReactNode } from 'react'

import EmptyTableSVG from '../../assets/images/empty-table.svg?react'
import * as S from './styles'

interface EmptyTableProps {
	title?: string
	subtitle?: string
	ctaText?: string
	ctaCallback?: () => void
	secondaryAction?: ReactNode
}

const EmptyTable = ({
	title,
	subtitle,
	ctaText,
	ctaCallback,
	secondaryAction,
}: EmptyTableProps) => (
	<Box
		alignItems="center"
		justifyContent="center"
		display="flex"
		flexDirection="column"
		mt="100px"
	>
		<EmptyTableSVG />
		<S.EmptyTableTitle>{title}</S.EmptyTableTitle>
		<S.EmptyTableSubtitle>{subtitle}</S.EmptyTableSubtitle>
		<S.EmptyTableActionButtons>
			{secondaryAction}
			{ctaCallback && (
				<Button
					variant="contained"
					color="primary"
					onClick={ctaCallback}
					data-testid="empty-table-primary-cta"
				>
					{ctaText}
				</Button>
			)}
		</S.EmptyTableActionButtons>
	</Box>
)

export { EmptyTable }
export type { EmptyTableProps }
